// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"e24ee23d","404":"16830b64","710":"e24ee23d","881":"69e32207"}[chunkId] + ".chunk.css";
};